<template>
  <b-container fluid>
    <!-- <b-breadcrumb style="background-color:#f8f9fa" :items="itemsBreadcrumb"></b-breadcrumb> -->

    <b-row>
      <b-col cols="12">
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="text-center">
            <p>Below are the approval forms filed by your employees. Click on "View & Edit" to review the approval form of your employee.</p>
          </div>
          <b-card class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0">
            <b-navbar toggleable="lg">
              <b-navbar-brand href="#">
                <strong style="color: #3b3e66">Approval List</strong>
              </b-navbar-brand>

              <b-collapse
                id="nav-collapse"
                is-nav
              >
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">
                  <b-nav-form>
                    <b-button
                      variant="outline-info"
                      size="sm"
                      class="mr-3"
                      @click="reloadTable"
                    >
                      Reload
                      <!-- <font-awesome-icon icon="sync" /> -->
                    </b-button>
                    <b-dropdown
                      class="mr-2"
                      variant="outline-warning"
                      size="sm"
                    >
                      <!-- style="margin-bottom: 10px;" -->
                      <template #button-content>
                        {{filterOption ? filterOption : 'Filter Status'}}
                      </template>
                      <b-dropdown-item @click="filterStatusApprovalsData('All',0)">All</b-dropdown-item>
                      <b-dropdown-item @click="filterStatusApprovalsData('Open',1)">Open</b-dropdown-item>
                      <b-dropdown-item @click="filterStatusApprovalsData('ON-HOLD',3)">ON-HOLD</b-dropdown-item>
                      <b-dropdown-item @click="filterStatusApprovalsData('APPROVED',4)">APPROVED</b-dropdown-item>
                      <b-dropdown-item @click="filterStatusApprovalsData('REJECTED',5)">REJECTED</b-dropdown-item>
                      <b-dropdown-item @click="filterStatusApprovalsData('In Review',6)">In Review</b-dropdown-item>
                    </b-dropdown>
                    <b-form onSubmit="return false;">
                      <b-form-group>
                        <b-input-group size="sm">
                          <b-form-input
                            type="search"
                            @input="onEmpltyFilter($event)"
                            v-model="filter"
                            @keyup.enter="filterInput"
                            placeholder="Type to Search"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              :disabled="!filter"
                              variant="outline-success"
                              @click="filterInput"
                            >Search</b-button>
                            <b-button
                              :disabled="disableFilter"
                              @click="clearFilters"
                            >Clear</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-form>
                  </b-nav-form>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>
            <b-table
              class="main-table"
              hover
              striped
              sticky-header="calc(100vh - 295px)"
              :busy.sync="isLoading"
              ref="table"
              id="my-table"
              :fields="staticFields"
              :items="getApprovalsData"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filterTable ? filter : null"
              style="background-color: #fff"
              selectable
              select-mode="single"
              @row-selected="onSelectRow"
              no-sort-reset
            >
              <template v-slot:cell(created_at)="data">
                <p>{{ createdAtDate(data.item.created_at) }}</p>
              </template>
              <template v-slot:cell(amount)="data">
                <p>{{ amountFormmater(data) }}</p>
              </template>
              <!-- <template v-slot:cell(first_name)="data">
                <p>{{ data.item.requested_by_first_name }}</p>
              </template>
              <template v-slot:cell(last_name)="data">
                <p>{{ data.item.requested_by_last_name }}</p>
              </template> -->
              <template v-slot:cell(title)="data">
                <p
                  class="link-text"
                  @click="onSelectRow(data.item)"
                >
                  {{ data.item.title }}
                </p>
              </template>
              <template v-slot:cell(view_edit)="data">
                <p
                  class="link-text"
                  @click="onSelectRow(data.item)"
                > View & Edit </p>
              </template>
              <template v-slot:cell(approval_status)="data">
                <span>
                  {{ getCountOfApprovers(data) }}/{{ data.item.approval_approvers.length ? data.item.approval_approvers.length : 1 }}
                </span>
                <span>
                  <b-progress
                    :value="getCountOfApprovers(data)"
                    :max="data.item.approval_approvers.length ? data.item.approval_approvers.length : 1"
                    variant="success"
                  ></b-progress>
                </span>
                <div class="mt-2">
                  <b-badge
                    v-if="data.item.status == 1"
                    variant="info"
                  >OPEN</b-badge>
                  <b-badge
                    v-else-if="data.item.status == 2"
                    variant="success"
                  >COMPLETED</b-badge>
                  <b-badge
                    v-else-if="data.item.status == 3"
                    variant="warning"
                  >ON-HOLD</b-badge>
                  <b-badge
                    v-else-if="data.item.status == 4"
                    variant="success"
                  >APPROVED</b-badge>
                  <b-badge
                    v-else-if="data.item.status == 5"
                    variant="danger"
                  >REJECTED</b-badge>
                  <b-badge
                    v-else-if="data.item.status == 6"
                    variant="warning"
                  >In Review</b-badge>
                <font-awesome-icon v-if="parseInt(data.item.filesCount) > 0" class="ml-2" icon="paperclip" />
                </div>
              </template>
            </b-table>
            <template v-slot:footer>
              <b-row>
                <b-col cols="2">
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-col>
                <b-col cols="6">
                  <p class="text-center">
                    Displaying Results From
                    <b>{{ fromRows }}</b> to
                    <b>{{ toRows }}</b>
                  </p>
                </b-col>
                <b-col cols="4">
                  <b-pagination
                    class="float-right"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                    aria-controls="my-table"
                  ></b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
export default {
  name: "EmployeeApprovalList",
  data () {
    return {
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "dashboard",
        },
        {
          text: "Gifts",
          href: "#",
          active: true,
        },
      ],
      disableFilter: true,
      filterStatus: 0,
      filterOption: null,
      isLoading: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      currentPage: 1,
      fromRows: 0,
      toRows: 0,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [
        {
          key: "first_name",
          label: "First Name",
          sortable: true,
        },
        {
          key: "last_name",
          label: "Last Name",
          sortable: true,
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
        },
        {
          key: "department",
          label: "Business Unit",
          sortable: true,
        },
        {
          key: "title",
          label: "Type",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Date Filed",
          sortable: true,
        },

        // {
        //     key: "currency",
        //     label: "Currency",
        //     sortable: false,

        // },
        {
          key: "amount",
          label: "Amount (USD)",
          sortable: false,
        },

        {
          key: "approval_status",
          label: "Approval Status",
          sortable: false,
        },
        {
          key: "view_edit",
          label: "Update Approval",
          sortable: false,
        },
        // {
        //   key: "approvers_name_list",
        //   label: "Approvers",
        //   sortable: false,
        // },
        // {
        //   key: "status",
        //   label: "Status",
        //   sortable: true,
        // },
      ],
      filterTable: false,
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.$store.state.selectedTaskType = 'Approval List';
    localStorage.setItem( 'selected_task_type', this.$store.state.selectedTaskType );
  },
  methods: {
    filterInput () {
      if ( this.filter ) {
        this.filterTable = true;
      }
      this.disableFilter = false;
      this.reloadTable();
    },
    onEmpltyFilter ( value ) {
      if ( value ) {
        return;
      } else {
        this.clearFilters();
      }
    },
    clearFilters () {
      this.filter = '';
      this.filterTable = false;
      this.filterStatus = 0;
      this.filterOption = null;
      this.disableFilter = true;
      this.reloadTable();
    },
    OpenDetailPage ( url ) {
      this.$router.push( url );
    },
    onSelectRow ( data ) {
      if ( Array.isArray( data ) ) {
        this.OpenDetailPage( '/gifts-approval/' + data[0].id + '/1' )
      } else if ( data.id ) {
        this.OpenDetailPage( '/gifts-approval/' + data.id + '/1' )
      }
    },
    getApproverName ( data ) {
      let firstName = data.first_name.toUpperCase();
      let lastName = data.last_name.toUpperCase();
      let name = firstName.charAt( 0 ) + lastName.charAt( 0 );

      return name;
    },
    getCountOfApprovers ( data ) {
      if ( data.item.approval_approvers.length ) {
        let approvedApproversCount = [];
        data.item.approval_approvers.map( ( approversData ) => {
          if ( approversData.status == 1 || approversData.status == 2 || approversData.status == 3 || approversData.status == 4 ) {
            approvedApproversCount.push( approversData );
          }
        } );
        return approvedApproversCount.length;
      } else {
        return 1;
      }
    },
    amountFormmater ( data ) {
      let amount = data.item.amount.replace( /\D/g, "" );
      return (amount == '') ? 'N/A' : '$'+amount.replace( /\B(?=(\d{3})+(?!\d))/g, "," );
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "my-table" );
    },
    filterStatusApprovalsData ( option, status ) {
      this.filterStatus = 0;
      this.filterOption = null;
      this.disableFilter = false;
      this.filterStatus = status;
      this.filterOption = option;
      this.reloadTable();
    },
    async getApprovalsData () {
      if ( this.sortBy || ( this.sortBy && this.sortBy == '' ) ) {
        this.sortBy = "id";
      }
      let formData = {
        filter_status: this.filterStatus,
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
        employee_id: localStorage.getItem( "employeeId" )
      };
      this.isLoading = true;
      let response = await HTTP(
        "post",
        "api/v1/approvals/get/all/list",
        formData
      );
      try {
        this.isLoading = false;
        this.totalRows = response.data.total;
        this.fromRows = response.data.from;
        this.toRows = response.data.to;
        this.filterTable = false;
        return response.data.data;
      } catch ( err ) {
        this.isLoading = false;
        return [err];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/table.css"; */
.fixed-bottom {
  right: auto !important;
  left: auto !important;
  width: 100%;
}
.card-body {
  padding: 0px;
}
.link-text {
  color: rgb(0 123 255);
  text-decoration: none;
  background-color: rgb(0 0 0 / 0%);
  cursor: pointer;
}
.link-text:hover {
  color: rgb(0 86 179);
  text-decoration: underline;
}
</style>
